import styled from "styled-components";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";

export const HeaderSection = styled("header")`
  padding: 1.25rem 0;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(230, 235, 241, 0.6);
  position: sticky;
  top: 0;
  z-index: 100;
  transition: all 0.3s ease;

  .ant-row-space-between {
    align-items: center;
    text-align: center;
  }

  /* Desktop layout - show only on larger screens */
  .desktop-header {
    @media only screen and (max-width: 890px) {
      display: none;
    }
  }

  /* Mobile layout - show only on smaller screens */
  .mobile-header {
    display: none;
    
    @media only screen and (max-width: 890px) {
      display: block;
    }
  }

  /* Mobile buttons styling */
  .mobile-buttons {
    div {
      align-items: center;
      gap: 12px !important;
    }
    
    a, a > div {
      margin: 0;
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 1rem 0;
    
    .mobile-buttons {
      div {
        gap: 10px !important;
      }
      
      a img, a > div {
        height: 44px !important;
        width: auto;
      }
      
      a > div {
        width: 110px !important;
        font-size: 10px !important;
      }
    }
  }
`;

export const LogoContainer = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  transition: all 0.3s ease;

  h2 {
    margin: 0;
    font-size: 3.95rem;
    font-weight: 500;
    font-family: 'Rubik', sans-serif;
    color: #6366f1;
    letter-spacing: -0.02em;
    transition: all 0.3s ease;
  }

  &:hover h2 {
    color: #4f46e5;
    transform: translateY(-1px);
  }

  @media only screen and (max-width: 768px) {
    h2 {
      font-size: 2.25rem;
    }
  }
`;

export const NavLink = styled("div")`
  display: inline-block;
  text-align: center;
`;

export const CustomNavLink = styled("div")`
  width: 203px;
  display: inline-block;

  @media only screen and (max-width: 411px) {
    width: 150px;
  }

  @media only screen and (max-width: 320px) {
    width: 118px;
  }
`;

export const ContactWrapper = styled("div")<any>`
  cursor: pointer;
  width: ${(p) => (p.width ? "100%" : "110px")};
  font-weight: 700;
  text-align: center;
  border-radius: 1.25rem;
  display: inline-block;
`;

export const Burger = styled("div")`
  display: none;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(99, 102, 241, 0.1);
  }

  svg {
    fill: #6366f1;
    font-size: 24px;
  }
`;

export const NotHidden = styled("div")`
  @media only screen and (max-width: 890px) {
    display: none;
  }
  
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const Menu = styled("h5")`
  font-size: 1.5rem;
  font-weight: 600;
  text-align: center;
  color: #1f2937;
  margin: 0;
`;

export const CustomNavLinkSmall = styled(NavLink)`
  font-size: 1.2rem;
  color: #18216d;
  transition: color 0.2s ease-in;
  margin: 0.5rem 1rem;

  @media only screen and (max-width: 768px) {
    margin: 1.25rem 2rem;
  }
`;

export const Label = styled("span")`
  font-weight: 500;
  color: #404041;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

export const Outline = styled(MenuOutlined)<any>`
  font-size: 24px;
`;

export const Span = styled("span")`
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  
  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 2px;
    bottom: -4px;
    left: 50%;
    background: linear-gradient(90deg, #6366f1, #8b5cf6);
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  &:hover,
  &:active,
  &:focus {
    color: #6366f1;
    transform: translateY(-1px);
  }
  
  &:hover::after {
    width: 100%;
  }
`;
